'use es6';

import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import PropTypes from 'prop-types';
import { EmailSubscriptionLinkOptions, LinkTypes, i18nKey } from '../../constants/link';
import { getHublVariable } from '../../utils/hubl';
import { jsx as _jsx } from "react/jsx-runtime";
const getTranslatedEmailSubscriptionLinkOptions = emailSubscriptionLinkTypes => emailSubscriptionLinkTypes.map(linkType => {
  const {
    text,
    help,
    value
  } = EmailSubscriptionLinkOptions[linkType];
  return {
    text: I18n.text(i18nKey(text)),
    help: I18n.text(i18nKey(help)),
    value
  };
});
export default function EmailSubscriptionLinkField(props) {
  const {
    href,
    onUpdate,
    emailSubscriptionLinkTypes
  } = props;
  return /*#__PURE__*/_jsx(FormControl, {
    label: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.EMAIL_SUBSCRIPTION}.label`),
    marginBlockStart: "0",
    children: /*#__PURE__*/_jsx(Select, {
      searchable: true,
      value: getHublVariable(href),
      onSelectedOptionChange: ({
        target: {
          value: data
        }
      }) => {
        onUpdate({
          href: `{{ ${data.value} }}`,
          linkDisplayName: data.text
        });
      },
      options: getTranslatedEmailSubscriptionLinkOptions(emailSubscriptionLinkTypes),
      placeholder: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.EMAIL_SUBSCRIPTION}.placeholder`)
    })
  });
}
EmailSubscriptionLinkField.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  emailSubscriptionLinkTypes: PropTypes.array.isRequired,
  href: PropTypes.string
};